<template>
  <div class="row sl-content">
    <div class="col-lg left-main-div-sl">
      <title-sl :title="$t('sl.home.title') " color="black" type="0" />

      <div class="left-main-div-subtitle-sl">{{ $t('sl.tocome') }} {{ $t('sl.hour') }}</div>
      <meetup-details :meetups="serviceLinesUpcoming" :isupcoming="isUpComing" />

      <div  class="left-main-div-subtitle-sl">
        <div>
          <!-- PR-2023 :{{ $t('sl.lastmeetup') }} -->
          {{ isAll?$t('sl.alllastmeetup'):$t('sl.12mlastmeetup') }}
        </div>
        <div>
          <a href="javascript:void(0)" class="green" @click="toogleFetchAll()">
            {{ isAll?$t('sl.seeless'):$t('sl.seeall') }}
          </a>          
        </div>
      </div>
      <!-- PR-2023 : supprime année et rendre scrollable -->
      <!-- <meetup-details :meetups="serviceLinesNewest" :isupcoming="isNotUpComing" /> -->
      <div class="past-metup-div">  
        <!-- <div class="date-title-div"><samp class="icon-date-meetup" @click="getSlPreviousYear">&#60;</samp> &nbsp; {{this.year}} &nbsp; <samp :class="this.year<this.currentYear?'icon-date-meetup':'d-none'" @click="getSlNextYear">&#62;</samp></div> -->
        <!-- <div class="black-separation"></div> -->
        <div class="sl-div-scroll">
          <div class="meetup-detail-container">
            <meetup-details :meetups="serviceLinesNewest" :isupcoming="isNotUpComing" :type="type" :all="allNewestServiceLines"/>
          </div>
        </div>
      </div>  
      <!-- PR-2023 -->
    </div>

    <div class="col-lg-2 right-main-div-sl">
      <calendar-sl />
      <div class="right-content-sl search-content">
        <div class="small-title-sl">{{ $t('sl.search.title') }}</div>
        <div class="search-div">
          <input class="search-input" placeholder="" v-model="search" @input="searchServiceLines" v-on:keyup.enter="searchServiceLines"/> <i @click="searchServiceLines" class="el-icon-search search"  ></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { mapActions } from "vuex";
  import MeetupDetails from '@/components/ServiceLines/MeetupDetails';
  import TitleSL from '@/components/ServiceLines/TitleSL';
  import CalendarSL from '@/components/ServiceLines/CalendarSL';
  import MeetupPerYear from '@/components/ServiceLines/MeetupPerYear';
  import { throttle } from '@/util/throttle';

  export default {
    name: 'meet-up', 
    components: {
      'meetup-details' : MeetupDetails,
      'title-sl': TitleSL,
      'calendar-sl': CalendarSL,
      'meetup-per-year': MeetupPerYear
    },
    props: {
    },
    data() {
      this.loadServiceLines();
      return {
        lang: Vue.i18n.locale(),
        serviceLinesNewest: [],
        serviceLinesUpcoming: [],
        allNewestServiceLines: [],
        serviceLinesRequest: {
          search: '',
          lang: Vue.i18n.locale(),
          type:0,
          filter:'upcoming'
        },
        search:'',
        type:0,
        year:2021,
        isUpComing:true,
        isNotUpComing: false,
        isAll: false
      };
    },
    computed: {
    },
    methods:{
      ...mapActions(["GetListServiceLines"]),
      async loadServiceLines() {
        this.getUpcoming();
        this.getNewest();
        this.getAllNewest();
      },
      async getUpcoming(){
        let sLRequest= {
            search: this.search,
            lang: Vue.i18n.locale(),
            type:this.type,
            filter:'upcoming'
          };
        await this.GetListServiceLines(sLRequest);
        this.serviceLinesUpcoming = this.$store.getters.AllServiceLines; 
      },
      async getNewest() {
        if(this.isAll == undefined) this.isAll = false;
        let sLRequest= {
            search: this.search,
            lang: Vue.i18n.locale(),
            type:this.type,
            filter:'newest',
            all: this.isAll
          };
        await this.GetListServiceLines(sLRequest);
        this.serviceLinesNewest = this.$store.getters.AllServiceLines; 
      },
      async getAllNewest() {
        let sLRequest= {
          lang: Vue.i18n.locale()
        };
        await this.GetListServiceLines(sLRequest);
        this.allNewestServiceLines = this.$store.getters.AllServiceLines;
      },      
      async searchServiceLines(){
        throttle(() => {
          this.getUpcoming();
          this.getNewest();
        }, 500); 
      },
      async toogleFetchAll() {
        this.isAll = !this.isAll;
        this.getNewest();
      }
    }
  };
</script>

